<template>
  <div>
    <header>
      <div class="back-link">
        <a href="/profile/portfolio">&#8592; Back to portfolio</a>
      </div>
    </header>
    <h1 class="align-center">Bulk upload</h1>
    <form :action="imageApi.bulk_images_upload_url" method="post" class="dropzone-area dropzone" id="uploadIllustrationDZ">

    </form>

    <div class="align-center vertical-padding" v-show="displayContinueBtn">
      <a class="big-purple-button" href="/profile/portfolio">Continue</a>
    </div>
  </div>
</template>

<script>
import imageApi from './../../../../api/image';

export default {
  mounted() {
    this.setupDropzone();
  },
  data() {
    return {
      imageApi,
      displayContinueBtn: false,
    };
  },
  methods: {
    setupDropzone() {
      let self = this;

      Dropzone.autoDiscover = false;
      Dropzone.options.uploadIllustrationDZ = {
        paramName: 'image',
        parallelUploads: 10,
        dictDefaultMessage: 'Drop files here to upload',
        timeout: configs.dropzoneTimeout,
        init: function() {
          this.on('addedfile', function(file) {
            self.displayContinueBtn = false;
          });

          this.on('queuecomplete', function(files) {
            self.displayContinueBtn = true;
          });
        },
        error: function (f, data) {
          let firstErrorKey = Object.keys(data.errors)[0],
            firstError = data.errors[firstErrorKey][0];    //Get first error

          f.previewElement.classList.add("dz-error");
          f.previewElement.querySelector("[data-dz-errormessage]").textContent = firstError;
        },
      };

      $("#uploadIllustrationDZ").dropzone();
    },
  },
};
</script>